<h5 class="footer-links__title">{{ header }}</h5>
<ul class="footer-links__list">
    <li class="footer-links__item" *ngFor="let link of links">
        <a [routerLink]="link.url" class="footer-links__link">{{ link.title }}</a>
    </li>
</ul>
